module.exports = __webpack_public_path__ + "img/不.0c03d638.gif";